import { render, staticRenderFns } from "./ChBaccSummary.vue?vue&type=template&id=9644c534"
import script from "./ChBaccSummary.vue?vue&type=script&lang=js"
export * from "./ChBaccSummary.vue?vue&type=script&lang=js"
import style0 from "./ChBaccSummary.vue?vue&type=style&index=0&id=9644c534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports